import React from 'react';
import {Routes, Route} from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import {publicRoutes, userProfileRoutes} from "./allRoutes";
import Layout from "../Layouts/index";

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {userProfileRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <Layout>
                                    {route.component}
                                </Layout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

            </Routes>
        </React.Fragment>
    );
};

export default Index;